import CompaniesService from "@/services/common/CompaniesService";

/**
 * @summary Cria o state de TrendAssetSelector.
 * @returns State de Company.
 */
const EmptyAssetSelectorStateFactory = function()
{
	return {
		assets:          CompaniesService.EmptyCompanyGeneratingUnitsFactory(),
		selectedAssets:  [],
		isHomeTrends:    false,
		isParkTrends:    false,
		searchQuery:     "",
		maxVisibleChips: 5,
		AvailableAssets: [],
		ShowToast:       false,
		ToastMessage:    "",
		ToastType:       0,

	};
};

export default { EmptyAssetSelectorStateFactory };